import { createAction } from 'typesafe-actions';
import { DialogElem, DialogsHandler } from './types';

export const showDialog = createAction('@components/showDialog')<DialogElem>();

function sortInPriorityOrder(a: DialogElem, b: DialogElem) {
  const ap = a.priority ?? 0;
  const bp = b.priority ?? 0;
  return bp - ap; // higher priority comes first
}

export const handleShowDialog: DialogsHandler<typeof showDialog> = (
  state,
  action,
) => {
  const dialogs = [action.payload, ...state.dialogs].sort(sortInPriorityOrder);
  return {
    ...state,
    dialogs,
  };
};
